import { forwardRef } from 'react';
import { Typography } from '../typography';
import { levelPresets } from './model';
import { Props } from './types';

export const Layout = forwardRef<HTMLElement, Props>(function Component(
  { level = 1, normalize = true, ...props },
  forwardedRef
) {
  return (
    <Typography
      {...props}
      baseClassName={levelPresets[level]}
      normalize={normalize}
      ref={forwardedRef}
    />
  );
});
